import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button, ButtonProps } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ClassesType } from '../types'

const useStyles = makeStyles(
  theme => ({
    button: {
      paddingLeft: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      fontWeight: 500,
      color: theme.colors.tabLabel,
      width: '100%',
      fontSize: '1.4rem',
      textTransform: 'none',
      textIndent: 20,
    },
    backArrow: {},
  }),
  { name: 'BackButton' },
)

export interface BackButtonProps extends ButtonProps {
  readonly classes?: ClassesType<typeof useStyles>
  readonly label?: React.ReactNode
}

const BackButton = ({
  classes: classesProp,
  label,
  ...rest
}: BackButtonProps) => {
  const classes = useStyles({ classes: classesProp })
  return (
    <Button
      classes={{
        root: classes.button,
      }}
      {...rest}
    >
      <ArrowBackIcon className={classes.backArrow} />
      {label}
    </Button>
  )
}

export default BackButton
